import Vue from 'vue'
import Router from 'vue-router'
import conferimento from './views/vettore.vue'
import analisi from './views/analisi.vue'
import distribuzione from './views/distribuzione.vue'
import confezionamento from './views/confezionamento.vue'
import trasformazione from './views/trasformazione.vue'
import login from './views/login.vue'
import home from './views/home.vue'
import notarizzazione from './views/notarizzazione.vue'
import axios from 'axios';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/login',
      name: 'login',
      component: login
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/conferimento',
      name: 'conferimento',
      component: conferimento
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/analisi',
      name: 'analisi',
      component: analisi
    },
    {
      path: '/distribuzione',
      name: 'distribuzione',
      component: distribuzione
    },
    {
      path: '/confezionamento',
      name: 'confezionamento',
      component: confezionamento
    },
    {
      path: '/trasformazione',
      name: 'trasformazione',
      component: trasformazione
    },
    {
      path: '/notarizzazione',
      name: 'notarizzazione',
      component: notarizzazione
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  const loggedin = localStorage.getItem('access_token')
  if(to.path != '/login') {
      if(checkToken(loggedin) === true) { 
        axios
        .get(process.env.VUE_APP_ROOT_API + 'carriers', {
          headers: {
            Authorization: `Bearer ${loggedin}`,
          },
        })
        .then(response => {
          // console.log(response)
          if (response.status === 200) {
            // console.log("returning true")
            next();
          } else if (response.status === 401) {
            // console.log("returning false")
            next('login');
          }
        })
        .catch(() => {
          // Handle error.
          return false
        })
      }
      else {
        next('login');
      }
      }
      else {
        next();
      }
  function checkToken(token) {

    // console.log(loggedin)
    if (!token) { 
      return false
     }
    else { 
      return true
    }
  }
})

export default router;